import template from './paylocity.html';
import controller from './paylocity.controller';

let paylocityComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default paylocityComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/paylocity.component.js